import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable, Input } from '@angular/core';
import { defaultCipherList } from 'constants';
import { BehaviorSubject, Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { MeetingResponse, CodeList } from '../models/basicMeetingModel';
import { Globals } from './global';
import { AgoraConfigService } from 'src/AgoraConfigService';
import { MeetingDataSource } from './meeting.datasource';
import * as Stomp from 'stompjs';
export interface Participant {
  id: string;
  name: string;
  isSpeaking: boolean;
  isMuted: boolean;
}
@Injectable({
  providedIn: 'root'
})

export class MeetingService {

  commonHeaders: any;
  meetingResponse !: MeetingResponse;
  agoraConfigObject: any;
  private stompClient: any;
  private participants = new BehaviorSubject<any[]>([]);
  private currentUser: Participant | null = null;
  private meetingId: string | null = null;

  constructor(private http: HttpClient, private globals: Globals, private agoraConfig: AgoraConfigService) {
    this.agoraConfigObject = this.agoraConfig.getConfig().endpoints;
    this.commonHeaders = new HttpHeaders().set('Content-Type', 'application/json;charset=utf-8').set("Access-Control-Allow-Origin", "*")
      .set("Access-Control-Allow-Headers", "*")
      .set("Access-Control-Allow-Methods", "GET,POST,PUT,DELETE");
  }

  //Service to create new meeting
  public createNewMeeting(reqJson: any) {
   // var rightsJSON={"moduleName":"createMeeting","moduleRights":"R"};
   // var params = new HttpParams();
    //params.set('rightsJSON', JSON.stringify(rightsJSON)); 
    // return this.http.post<any>(`${environment.createNewMeetingUrl}`, reqJson, { headers: this.commonHeaders, observe: 'response'});
    return this.http.post<any>(`${this.agoraConfig.getConfig().apiBaseUrl}${this.agoraConfigObject.meeting}`+"createMeeting", reqJson, { headers: this.commonHeaders, observe: 'response'});

  }

  //Method to fetch meeting Information
  public fetchMeetingInfo(meetingId: any) {
    //var rightsJSON={"moduleName":"fetchMeeting","moduleRights":"R"};
    //var params = new HttpParams().append('rightsJSON', JSON.stringify(rightsJSON)); 
        // return this.http.get<any>("http://localhost:2021/meeting/getMeetingDetails/"+ meetingId, { headers: this.commonHeaders, observe: 'response' });

    return this.http.get<any>(`${this.agoraConfig.getConfig().apiBaseUrl}${this.agoraConfigObject.meeting}` +"getMeetingDetails/"+ meetingId, { headers: this.commonHeaders, observe: 'response' });
  }
  public fetchMeetingConfInfo(jsonObj: any) {
    //var rightsJSON={"moduleName":"fetchMeeting","moduleRights":"R"};
    //var params = new HttpParams().append('rightsJSON', JSON.stringify(rightsJSON)); 
    return this.http.post<any>(`${this.agoraConfig.getConfig().apiBaseUrl}${this.agoraConfigObject.meeting}`+"getMeetingDetailsInfo", jsonObj, { headers: this.commonHeaders, observe: 'response' });
  }
  //Method to fetch meeting type
  public fetchMeetingType() {
    return this.http.get<any>(`${this.agoraConfig.getConfig().apiBaseUrl}${this.agoraConfigObject.meeting}`+"getMeetingTypeList", { headers: this.commonHeaders, observe: 'response' });
  }
  //method to get timezone names
  public fetchTimeZone() {
    return this.http.get<any>(`${this.agoraConfig.getConfig().apiBaseUrl}${this.agoraConfigObject.meeting}`+"getTimeZoneNames", { headers: this.commonHeaders, observe: 'response' });
  }

  public fetchCalendarType() {
    return this.http.get<any>(`${this.agoraConfig.getConfig().apiBaseUrl}${this.agoraConfigObject.meeting}`+"getCalendarType", { headers: this.commonHeaders, observe: 'response' });
  }
  //Method to fetch task status list
  getTaskStatus() {
    return this.http.get<any>(`${this.agoraConfig.getConfig().apiBaseUrl}${this.agoraConfigObject.task}`+"getTaskStatusList", { headers: this.commonHeaders, observe: 'response' });
  }
  //Method to fetch Meeting Medium CodeList 
  public fetchMeetingMediumList() {
    return this.http.get<any>(`${this.agoraConfig.getConfig().apiBaseUrl}${this.agoraConfigObject.meeting}`+"getMeetingMediumList", { headers: this.commonHeaders, observe: 'response' });
  }
  //method to update meeting
  public updateMeeting(meetingId: any, updateMeeting: any) {
    return this.http.patch<any>(`${this.agoraConfig.getConfig().apiBaseUrl}${this.agoraConfigObject.meeting}`+"updateMeeting/" + meetingId, updateMeeting, { headers: this.commonHeaders, observe: 'response' });
  }
  //method to update recurring meeting info while clicking all option
  public updateRecurringInfo(reqJson: any) {
    return this.http.patch<any>(`${this.agoraConfig.getConfig().apiBaseUrl}${this.agoraConfigObject.recurMeeting}`+"updateRecurringInfo", reqJson, { headers: this.commonHeaders, observe: 'response' });
    //return this.http.patch<any>(`http://localhost:2021/recurmeeting/updateRecurringInfo`, reqJson, { headers: this.commonHeaders, observe: 'response' });


  }

 //toget all meeting dates inbetween start and end date
 public getMeetingDates(reqJson: any) {
  return this.http.post<any>(`${this.agoraConfig.getConfig().apiBaseUrl}${this.agoraConfigObject.recurMeeting}`+"getMeetingDates", reqJson, { headers: this.commonHeaders, observe: 'response' });
}


public monthlyMeetingStartDate(reqJson: any) {
  return this.http.post<any>(`${this.agoraConfig.getConfig().apiBaseUrl}${this.agoraConfigObject.recurMeeting}`+"monthlyMeetingStartDate", reqJson, { headers: this.commonHeaders, observe: 'response' });
}

public yearlyMeetingStartDate(reqJson: any) {
  return this.http.post<any>(`${this.agoraConfig.getConfig().apiBaseUrl}${this.agoraConfigObject.recurMeeting}`+"yearlyMeetingStartDate", reqJson, { headers: this.commonHeaders, observe: 'response' });
}

public getWeekOfMonth(reqJson: any) {
  return this.http.post<any>(`${this.agoraConfig.getConfig().apiBaseUrl}${this.agoraConfigObject.recurMeeting}`+"weekOfMonth", reqJson, { headers: this.commonHeaders, observe: 'response' });
}



  //fetchTask Information UI Team Change
  fetchTaskInfo(taskId : any){
    return this.http.get<any>(`${this.agoraConfig.getConfig().apiBaseUrl}${this.agoraConfigObject.task}`+"fetchTask/" + taskId, { headers: this.commonHeaders, observe: 'response' });
  }

  //method to save agenda
  saveModernAgenda(agendajsonString: string) {
    return this.http.post<any>(`${this.agoraConfig.getConfig().apiBaseUrl}${this.agoraConfigObject.agenda}`+"createAgenda", agendajsonString, { headers: this.commonHeaders, observe: 'response' });
  }
  //method to save follow up meeting
  saveFollowupMeeting(reqString: string) {
    return this.http.post<any>(`${this.agoraConfig.getConfig().apiBaseUrl}${this.agoraConfigObject.meeting}`+"saveFollowupMeeting", reqString, { headers: this.commonHeaders, observe: 'response' });
  }
  
  //method to delete agenda
  deleteModernAgenda(meetingId: any, agendaId: any) {
    return this.http.delete<any>(`${this.agoraConfig.getConfig().apiBaseUrl}${this.agoraConfigObject.agenda}` + "deleteAgenda/" + meetingId + "/" + agendaId, { headers: this.commonHeaders, observe: 'response' });
  }
  //method to update agenda
  updateModernAgenda(agendajsonString: string, agendaId: any) {
    return this.http.patch<any>(`${this.agoraConfig.getConfig().apiBaseUrl}${this.agoraConfigObject.agenda}` + "updateAgenda/" + agendaId, agendajsonString, { headers: this.commonHeaders, observe: 'response' });
  }
  //method to update group task
  updateGroupTask(taskjson:any) {
    return this.http.put<any>(`${this.agoraConfig.getConfig().apiBaseUrl}${this.agoraConfigObject.task}`+"updateDashboardTaskInfo", taskjson, { headers: this.commonHeaders, observe: 'response' });
  }

  //Method to fetch agenda by meetingid
  fetchAgendaListByMeetingId(meetingId:any){
    var jsonReq:any={};
    jsonReq["meetingId"] = meetingId;
    jsonReq["userId"] = this.globals.userId;
    jsonReq["orgCode"] = this.globals.orgCode;
    return this.http.post<any>(`${this.agoraConfig.getConfig().apiBaseUrl}${this.agoraConfigObject.agenda}`+"fetchAgendaListByMeeting", JSON.stringify(jsonReq), { headers: this.commonHeaders, observe: 'response' });
  }
  fetchAgendaWithSubListByMeetingId(meetingId:any){
    var jsonReq:any={};
    jsonReq["meetingId"] = meetingId;
    jsonReq["userId"] = this.globals.userId;
    jsonReq["orgCode"] = this.globals.orgCode;
    return this.http.post<any>(`${this.agoraConfig.getConfig().apiBaseUrl}${this.agoraConfigObject.agenda}`+"fetchAgendaWithSubTopics", JSON.stringify(jsonReq), { headers: this.commonHeaders, observe: 'response' });
  }

  //method to save note/decision/task
  saveModernMinutes(minJsonString: string, serviceUrl: any, reqType: any) {
    if (reqType == "Y") {
      return this.http.put<any>(serviceUrl, minJsonString, { headers: this.commonHeaders, observe: 'response' });
    } else {
      return this.http.post<any>(serviceUrl, minJsonString, { headers: this.commonHeaders, observe: 'response' });
    }
  }
  //used to update common task status
  updateCommonTaskStatus(taskId: any, meetingId: any, taskStatus: any, updateTaskJson: any) {
    return this.http.put<any>(`${this.agoraConfig.getConfig().apiBaseUrl}${this.agoraConfigObject.task}`+"updateTaskCommonStatus", updateTaskJson, { headers: this.commonHeaders, observe: 'response' });
  }

  //method to save note/decision/task
  updateMinSequence(minJsonString: any) {
    
    return this.http.put<any>(`${this.agoraConfig.getConfig().apiBaseUrl}${this.agoraConfigObject.agenda}`+"updateMinuteSeq", minJsonString, { headers: this.commonHeaders, observe: 'response' });
  }
    updateAgendaSequence(agendaSeqReq: any) {
       return this.http.post<any>(`${this.agoraConfig.getConfig().apiBaseUrl}${this.agoraConfigObject.agenda}`+"agendaSeqOrder", agendaSeqReq, { headers: this.commonHeaders, observe: 'response' });
    }

    fetchAgendaMinutesList(reqObj: any) {
      return this.http.post<any>(`${this.agoraConfig.getConfig().apiBaseUrl}${this.agoraConfigObject.agenda}`+"fetchAgendaMinutes", reqObj, { headers: this.commonHeaders, observe: 'response' });
  }

  // method to fetch the meeting type to meetingTypeResponse modal
  fetchMeetingTypeInfo() {
    return new Promise((resolve, reject) => {
        this.fetchMeetingType().subscribe(
          (meetingTypeRes: any) => {
            this.globals.globalMeetingType = meetingTypeRes;
            resolve(meetingTypeRes.body);
          },
          err => {
            
          }).add(() => {
          });
      
    });
  }
  updateRecurringMeetingInfo(meetingObj:any){
  //  var recurCheckBox = this.recurChange.value;
    return new Promise((resolve, reject) => {
      if(meetingObj.recurDetailsId!=null ){
        var reqJson = {
          "meetingId": meetingObj.meetingId,
          "recurDetailsId":meetingObj.recurDetailsId
        }
        this.updateRecurringInfo(reqJson).subscribe((responsedata:any) => {
          resolve(responsedata.body);
        })
      }
    });
  }
  // method to fetch the meeting type to meetingTypeResponse modal
  fetchTimeZoneName() {
    return new Promise((resolve, reject) => {
        this.fetchTimeZone().subscribe(
          (meetingRes: any) => {
            this.globals.globalTimezoneName = meetingRes;
            resolve(meetingRes.body);
          },
          err => {
            
          }).add(() => {
          });
      
    });
  }
//method to fetch calendar type from codelist
  fetchCalendarTYpe() {
    return new Promise((resolve, reject) => {
        this.fetchCalendarType().subscribe(
          (meetingRes: any) => {
            this.globals.globalTimezoneName = meetingRes;
            resolve(meetingRes.body);
          },
          err => {
            
          }).add(() => {
          });
      
    });
  }

  // method to fetch the meeting type to meetingTypeResponse modal
  fetchMeetingMedium() {
    return new Promise((resolve, reject) => {
        this.fetchMeetingMediumList().subscribe(
          (meetMediumRes: any) => {
            this.globals.globalMeetingMedium = meetMediumRes
            resolve(meetMediumRes.body);
            
          },
          err => {
            
          }).add(() => {
          });
      
     
    });
  }

  fetchPrevAgendaHis(curAgInfo:any,pageStart:any,pageLength:any){
    return new Promise((resolve, reject) => {
      //var meetingId = curAgInfo.meetingId;
      //var agendaId= curAgInfo.agendaId;
      var reqJson ={
        "meetingId": curAgInfo.meetingId,
        "agendaId" : curAgInfo.agendaId,
        //"pagination":{"idisplayLength":10,"idisplayStart":0},
        "pageStart":pageStart,
        "pageLength":pageLength,
        "visitorTimeZone":this.globals.vTimeZone
      }
      this.viewPrevAgendaInfo(reqJson).subscribe((resp:any)=>{
        if(resp!=undefined && resp!=null){
          //this.prevAgendaInfoList = resp;
          resolve(resp.body);
        }
      });
    });
  }
    //Method to fetch meeting Information
    public scheduleMeeting(jsonReq: any) {
      return this.http.post<any>(`${this.agoraConfig.getConfig().apiBaseUrl}${this.agoraConfigObject.meeting}`+'scheduleMeeting',jsonReq, { headers: this.commonHeaders,observe: 'response'  });
      //return this.http.post<any>('http://localhost:2021/meeting/scheduleMeeting',jsonReq, { headers: this.commonHeaders,observe: 'response'  });
    }

    public viewPrevAgendaInfo(req: any) {
      return this.http.post<any>(`${this.agoraConfig.getConfig().apiBaseUrl}${this.agoraConfigObject.agenda}`+"fetchPreviousMeetingInfoByAgendaId",req, { headers: this.commonHeaders,observe: 'response'  });
    }

    

    //Service to create new meeting
    public endMeeting(reqJson: any) {
      return this.http.post<any>(`${this.agoraConfig.getConfig().apiBaseUrl}${this.agoraConfigObject.meeting}`+"endMeeting", reqJson, { headers: this.commonHeaders, observe: 'response' });
    }

    //Service to create new meeting
    public startMeeting(reqJson: any) {
      return this.http.post<any>(`${this.agoraConfig.getConfig().apiBaseUrl}${this.agoraConfigObject.meeting}`+"startMeeting", reqJson, { headers: this.commonHeaders, observe: 'response' });
    }
    
    fetchAgendaWithMinutes(agendajsonString: any) {
      
      return this.http.post<any>(`${this.agoraConfig.getConfig().apiBaseUrl}${this.agoraConfigObject.agenda}`+"fetchAgendaDTOByAgendaId", agendajsonString, { headers: this.commonHeaders, observe: 'response' });
    }
   deleteMeeting(meetingVal:any){
     return this.http.put<any>(`${this.agoraConfig.getConfig().apiBaseUrl}${this.agoraConfigObject.meeting}`+"deleteMeeting/"+ meetingVal.meetingId,meetingVal, { headers: this.commonHeaders, observe: 'response' });
   }
   cancelMeeting(meetingVal:any){
    return this.http.post<any>(`${this.agoraConfig.getConfig().apiBaseUrl}${this.agoraConfigObject.meeting}`+"cancelMeeting/"+ meetingVal.meetingId,meetingVal, { headers: this.commonHeaders, observe: 'response' });
  }
  fetchDecision(decisionId:any){
    return this.http.get<any>(`${this.agoraConfig.getConfig().apiBaseUrl}${this.agoraConfigObject.decision}`+"fetchDecision/"+ decisionId, { headers: this.commonHeaders, observe: 'response' });
  }
  fetchNotes(notesId:any){
    return this.http.get<any>(`${this.agoraConfig.getConfig().apiBaseUrl}${this.agoraConfigObject.note}`+"fetchNote/"+ notesId, { headers: this.commonHeaders, observe: 'response' });
  }
  getHistory(notesId:any){
    return this.http.get<any>(`${this.agoraConfig.getConfig().apiBaseUrl}${this.agoraConfigObject.note}`+"getAuditRecord/"+ notesId, { headers: this.commonHeaders, observe: 'response' });
  }
  getDecisionHistory(decisionId:any){
    return this.http.get<any>(`${this.agoraConfig.getConfig().apiBaseUrl}${this.agoraConfigObject.decision}`+"getAuditRecord/"+ decisionId, { headers: this.commonHeaders, observe: 'response' });
  }
  getTaskHistory(taskId:any){
    return this.http.get<any>(`${this.agoraConfig.getConfig().apiBaseUrl}${this.agoraConfigObject.task}`+"getAuditRecord/"+ taskId, { headers: this.commonHeaders, observe: 'response' });
  }
  saveMeetingToLink(req:any){
    return this.http.post<any>(`${this.agoraConfig.getConfig().apiBaseUrl}${this.agoraConfigObject.meeting}`+"linkMeeting", req, { headers: this.commonHeaders, observe: 'response' });
  }
  saveMeetingToUnlink(req:any){
    return this.http.post<any>(`${this.agoraConfig.getConfig().apiBaseUrl}${this.agoraConfigObject.meeting}`+"unLinkMeeting", req, { headers: this.commonHeaders, observe: 'response' });
  }
  getLinkedMeeting(req:any){
    return this.http.post<any>(`${this.agoraConfig.getConfig().apiBaseUrl}${this.agoraConfigObject.meeting}`+"fetchLinkedMeeting", req, { headers: this.commonHeaders, observe: 'response' });
  }
  copyMeeting(meetingJson:any) {
    return this.http.put<any>(`${this.agoraConfig.getConfig().apiBaseUrl}${this.agoraConfigObject.meeting}`+"copyMeeting/"+ meetingJson.meetingId, meetingJson, { headers: this.commonHeaders, observe: 'response' });
  }
  saveAsTemplate(meetingTemplateJson:any) {
    return this.http.put<any>(`${this.agoraConfig.getConfig().apiBaseUrl}${this.agoraConfigObject.template}`+"/saveAsMeetingTemplate/"+ meetingTemplateJson.meetingId, meetingTemplateJson, { headers: this.commonHeaders, observe: 'response' });
  }
  getCategoryDetails() {
    return this.http.get<any>(`${this.agoraConfig.getConfig().apiBaseUrl}${this.agoraConfigObject.template}`+"/getCategoryDetails");
  }

  getTemplateNames(template:any) {
    return this.http.get<any>(`${this.agoraConfig.getConfig().apiBaseUrl}${this.agoraConfigObject.template}`+"/getTemplateNames/"+template);
  }
  getMeetingId(template:any) {
    return this.http.get<any>(`${this.agoraConfig.getConfig().apiBaseUrl}${this.agoraConfigObject.template}`+"/getMeetingId/"+template);
  }


  loadTemplate(reqJSON:any) {
    return this.http.post<any>(`${this.agoraConfig.getConfig().apiBaseUrl}${this.agoraConfigObject.template}`+"/loadTemplate/"+reqJSON.meetingId, reqJSON, { headers: this.commonHeaders, observe: 'response' });
   // return this.http.get<any>(`${this.agoraConfig.getConfig().apiBaseUrl}${this.agoraConfigObject.template}`+"/getMeetingId/"+template);
  }
  loadCategory(reqJSON:any) {
    return this.http.post<any>(`${this.agoraConfig.getConfig().apiBaseUrl}${this.agoraConfigObject.template}`+"/getCategories", reqJSON, { headers: this.commonHeaders, observe: 'response' });
   // return this.http.get<any>(`${this.agoraConfig.getConfig().apiBaseUrl}${this.agoraConfigObject.template}`+"/getMeetingId/"+template);
  }
  createRecurParentMeeting(reqJSON:any) {
    return this.http.post<any>(`${this.agoraConfig.getConfig().apiBaseUrl}${this.agoraConfigObject.recurMeeting}`+"createRecurParentMeeting", reqJSON, { headers: this.commonHeaders, observe: 'response' });
  }
  createRecurChildMeeting(reqJSON:any) {
    return this.http.post<any>(`${this.agoraConfig.getConfig().apiBaseUrl}${this.agoraConfigObject.recurMeeting}`+"createRecurChildMeeting", reqJSON, { headers: this.commonHeaders, observe: 'response' });
  }
  getTemplateNameByCategory(reqJSON:any) {
    return this.http.post<any>(`${this.agoraConfig.getConfig().apiBaseUrl}${this.agoraConfigObject.template}`+"/getTemplateNameByCategory", reqJSON, { headers: this.commonHeaders, observe: 'response' });
   // return this.http.get<any>(`${this.agoraConfig.getConfig().apiBaseUrl}${this.agoraConfigObject.template}`+"/getMeetingId/"+template);
  }
  updateConfidentialMeeting(meetingId: any,taskjson:any) {
    return this.http.patch<any>(`${this.agoraConfig.getConfig().apiBaseUrl}${this.agoraConfigObject.meeting}`+"updateMeeting/"+meetingId, taskjson, { headers: this.commonHeaders, observe: 'response' });
  }
  getTemplateMeetingId(templateName:any) {
    return this.http.get<any>(`${this.agoraConfig.getConfig().apiBaseUrl}${this.agoraConfigObject.template}`+"/getMeetingId/"+templateName, { headers: this.commonHeaders, observe: 'response' });
   // return this.http.get<any>(`${this.agoraConfig.getConfig().apiBaseUrl}${this.agoraConfigObject.template}`+"/getMeetingId/"+template);
  }
  getTemplatesByName(reqJSON:any) {
    return this.http.post<any>(`${this.agoraConfig.getConfig().apiBaseUrl}${this.agoraConfigObject.template}`+"/searchTemplateByName", reqJSON, { headers: this.commonHeaders, observe: 'response' });
   // return this.http.get<any>(`${this.agoraConfig.getConfig().apiBaseUrl}${this.agoraConfigObject.template}`+"/getMeetingId/"+template);
  }
  //method to update meeting
  public updateMeetingTitle(meetingId: any, updateMeeting: any) {
    return this.http.patch<any>(`${this.agoraConfig.getConfig().apiBaseUrl}${this.agoraConfigObject.meeting}`+"updateMeetingTitle/" + meetingId, updateMeeting, { headers: this.commonHeaders, observe: 'response' });
  }
  getTemplateByTemplateId(templateId:any) {
    return this.http.get<any>(`${this.agoraConfig.getConfig().apiBaseUrl}${this.agoraConfigObject.template}`+"/getTemplateDetails/"+templateId, { headers: this.commonHeaders, observe: 'response' });
   // return this.http.get<any>(`${this.agoraConfig.getConfig().apiBaseUrl}${this.agoraConfigObject.template}`+"/getMeetingId/"+template);
  }  
  public saveTaskAgendaId(jsonReq: any,taskId : any) {
    return this.http.put<any>(`${this.agoraConfig.getConfig().apiBaseUrl}${this.agoraConfigObject.task}` +"updateTaskAgendaId/"+taskId,jsonReq, { headers: this.commonHeaders,observe: 'response'});
  }

  public getMomApprovedUserNames (meetingId:any){
    return this.http.post<any>(`${this.agoraConfig.getConfig().apiBaseUrl}${this.agoraConfigObject.minutes}`+"fetchMomApprovedUserName/" + meetingId, { headers: this.commonHeaders,observe: 'response'});
  }
 
  private messageSource = new BehaviorSubject<string>('service');
  currentMessage = this.messageSource.asObservable();

  changeMessage(message: any) {
    
    this.messageSource.next(message);
    
    this.returnChangeMessage();

  }

  returnChangeMessage(){
    return this.messageSource;
  }
  public updateMeetingConversation(meetingId: any, updateMeeting: any) {
    return this.http.patch<any>(`${this.agoraConfig.getConfig().apiBaseUrl}${this.agoraConfigObject.meeting}`+"updateMeetingConversation/" + meetingId, updateMeeting, { headers: this.commonHeaders, observe: 'response' });
  }
  public updateMeetingSpeechContent(meetingId: any, updateMeeting: any) {
    return this.http.patch<any>(`${this.agoraConfig.getConfig().apiBaseUrl}${this.agoraConfigObject.meeting}`+"updateMeetingSpeechContent/" + meetingId, updateMeeting, { headers: this.commonHeaders, observe: 'response' });
  }

  sendNotification(param:any){
    return this.http.post<any>(`${this.agoraConfig.getConfig().apiBaseUrl}${this.agoraConfigObject.meeting}`+'sendNotification',param,{ headers: this.commonHeaders,observe: 'response'});
  }

  getDefaultMessage(){
    return this.http.post<any>(`${this.agoraConfig.getConfig().apiBaseUrl}${this.agoraConfigObject.meeting}`+'defaultMessage',{ headers: this.commonHeaders,observe: 'response'});
  }
  getDocList() {
    return this.http.post<any>(`${this.agoraConfig.getConfig().apiBaseUrl}${this.agoraConfigObject.meeting}`+'getDocmeetTypeList', { headers: this.commonHeaders, observe: 'response' });
  }

  sendNotificationTask(param:any){
    return this.http.post<any>(`${this.agoraConfig.getConfig().apiBaseUrl}${this.agoraConfigObject.task}`+"sendTaskNotification",param, { headers: this.commonHeaders, observe: 'response' });
  }  

  getAllNotesHistory(jsonObj:any){
    return this.http.post<any>(`${this.agoraConfig.getConfig().apiBaseUrl}${this.agoraConfigObject.agenda}`+"fetchAgendaListofHistoryByMeeting", jsonObj, { headers: this.commonHeaders, observe: 'response' });
  }
  getMeetingDetailsHistory(jsonObj:any){
    return this.http.post<any>(`${this.agoraConfig.getConfig().apiBaseUrl}${this.agoraConfigObject.meeting}`+"getMeetingHistoryDetails", jsonObj, { headers: this.commonHeaders, observe: 'response' });
  }
  getAgendaHistory(jsonObj:any){
    return this.http.post<any>(`${this.agoraConfig.getConfig().apiBaseUrl}${this.agoraConfigObject.agenda}`+"fetchAllAgendaListofHistoryByMeeting", jsonObj, { headers: this.commonHeaders, observe: 'response' });
  }
  getAllAttendeeHistory(meetingId:any){
    return this.http.get<any>(`${this.agoraConfig.getConfig().apiBaseUrl}${this.agoraConfigObject.attendee}`+"/getAttendeeHistoryListByMeetingId/"+ meetingId, { headers: this.commonHeaders, observe: 'response' });
  }
  getMeetingHistory(meetingId:any){
    return this.http.get<any>(`${this.agoraConfig.getConfig().apiBaseUrl}${this.agoraConfigObject.meeting}`+"getAuditRecord/"+ meetingId, { headers: this.commonHeaders, observe: 'response' });
  }
  getAllDecisionHistory(jsonObj:any){
    return this.http.post<any>(`${this.agoraConfig.getConfig().apiBaseUrl}${this.agoraConfigObject.agenda}`+"fetchAgendaListofHistoryByMeeting", jsonObj, { headers: this.commonHeaders, observe: 'response' });
  }
  getAllTaskHistory(jsonObj:any){
    return this.http.post<any>(`${this.agoraConfig.getConfig().apiBaseUrl}${this.agoraConfigObject.agenda}`+"fetchAgendaListofHistoryByMeeting", jsonObj, { headers: this.commonHeaders, observe: 'response' });
  }

  public getTZNameByCode(jsonObj:any) {
    return this.http.post<any>(`${this.agoraConfig.getConfig().apiBaseUrl}${this.agoraConfigObject.codelist}`+"getCodelistByParentAndCode", jsonObj, { headers: this.commonHeaders, observe: 'response' });
  }

  public fetchMeetingWithStatusObject(meetingId: any) { 
    return this.http.get<any>(`${this.agoraConfig.getConfig().apiBaseUrl}${this.agoraConfigObject.meeting}`+"fetchMeetingStatusCode/" + meetingId, { headers: this.commonHeaders, observe: 'response' });
  }
  
  public saveMinutesTemplate(tempReq:any,saveTemplate:any){
    return this.http.post<any>(`${this.agoraConfig.getConfig().apiBaseUrl}${this.agoraConfigObject.template}`+"/saveMinutesTemplate/"+saveTemplate, tempReq , { headers: this.commonHeaders, observe: 'response' });
    // return this.http.post<any>(`http://192.168.193.47:2027/meetingtemplate/saveMinutesTemplate/`+saveTemplate, tempReq , { headers: this.commonHeaders, observe: 'response' });
  }
  public fetchMinutesTemplate(tempReq:any){
        return this.http.post<any>(`${this.agoraConfig.getConfig().apiBaseUrl}${this.agoraConfigObject.template}`+"/fetchMinutesTemplate", tempReq , { headers: this.commonHeaders, observe: 'response' });
    // return this.http.post<any>(`http://192.168.193.47:2027/meetingtemplate/fetchTemplate`, tempReq , { headers: this.commonHeaders, observe: 'response' });
  }

  public fetchMinutesTemplateById(tempReq:any){
    return this.http.post<any>(`${this.agoraConfig.getConfig().apiBaseUrl}${this.agoraConfigObject.template}`+"/fetchMinutesTemplateById", tempReq , { headers: this.commonHeaders, observe: 'response' });
// return this.http.post<any>(`http://192.168.193.47:2027/meetingtemplate/fetchTemplate`, tempReq , { headers: this.commonHeaders, observe: 'response' });
}

  public agendaMinutesWithMeetingId(reqJson: any) {   
    return this.http.post<any>(`${this.agoraConfig.getConfig().apiBaseUrl}${this.agoraConfigObject.agenda}`+"agendaMinutesWithMeetingId", reqJson, { headers: this.commonHeaders, observe: 'response' });
 }

 public isMinTemplateExists(tempReq:any){
  return this.http.post<any>(`${this.agoraConfig.getConfig().apiBaseUrl}${this.agoraConfigObject.template}`+"/isMinTemplateExists", tempReq , { headers: this.commonHeaders, observe: 'response' });
}
linkTasksToNote(noteId: any, reqObj: any) {
  return this.http.put<any>(`${this.agoraConfig.getConfig().apiBaseUrl}${this.agoraConfigObject.note}`+"editNote/"+noteId, reqObj)
}

initializeWebSocketConnection(meetingId: string): void {
  const socket = new WebSocket(`${environment.webSocketEndPoint}`);
  this.stompClient = Stomp.over(socket);
  this.stompClient.connect({}, () => {
    this.joinAudioToText(meetingId);
  });
}
  disconnectWebSocket() {
    if (this.stompClient != null && this.stompClient.connected == true) {
      this.stompClient.disconnect();
    }
  }
  public joinAudioToText(meetingId: string): void {
    this.meetingId = meetingId;
    this.currentUser = {
      id: localStorage.getItem("userId")!,
      name: localStorage.getItem("userName")!,
      isSpeaking: false,
      isMuted: false
    };
    this.stompClient.send('/app/join', {}, JSON.stringify({
      meetingId,
      participantId: this.currentUser.id,
      participantName: this.currentUser.name
    }));
 
    this.stompClient.subscribe(`/topic/meeting/${meetingId}/participants`, (message: any) => {
      const parsed = JSON.parse(message.body);
      this.participants.next(parsed.participants);
    });
  }
  public leaveAudioToText(): void {
    if (this.meetingId && this.currentUser) {
      this.stompClient.send('/app/leave', {}, JSON.stringify({
        meetingId: this.meetingId,
        participantId: this.currentUser.id
      }));
      this.meetingId = null;
      this.currentUser = null;
      this.participants.next([]);
    }
  }
  public getParticipants(): Observable<Participant[]> {
    return this.participants.asObservable();
  }
  public getCurrentUser(): Participant | null {
    return this.currentUser;
  }
  public fetchSpeechContent(meetingId: any) {
      return this.http.get<any>(`${this.agoraConfig.getConfig().apiBaseUrl}${this.agoraConfigObject.attachment}`+"getSpeechContent/"+meetingId , { headers: this.commonHeaders, observe: 'response' });
  }
 
linkNotesToTask(taskId: any,reqObj: any) {
    return this.http.put<any>(`${this.agoraConfig.getConfig().apiBaseUrl}${this.agoraConfigObject.task}`+"updateTaskInfo", reqObj);
}

fetchLinkedNotesByNoteIds(linkedNoteIds: string[]) {
  // Wrap in an object matching NoteDTO structure
  const payload = { linkedNoteIds }; 
    return this.http.post<any>(`${this.agoraConfig.getConfig().apiBaseUrl}${this.agoraConfigObject.note}fetchNotesByNoteIds`, payload);
}
fetchNotesByMeetingId(meetingId: number, decryptKey?: string){
  const requestBody = {
    meetingId: meetingId,
    decryptKey: decryptKey || null
  };
  return this.http.post<any[]>(`${this.agoraConfig.getConfig().apiBaseUrl}${this.agoraConfigObject.note}fetchNotesByMeetingId`, requestBody);
}
fetchTaskByMeetingId(meetingId: number, decryptKey?: string){
  const requestBody = {
    meetingId: meetingId,
    decryptKey: decryptKey || null
  };
  return this.http.post<any[]>(`${this.agoraConfig.getConfig().apiBaseUrl}${this.agoraConfigObject.task}fetchTaskByMeetingId`, requestBody);
}
fetchAgendaListByMeeting(meetingId: number) {
  return this.http.get<any>(
    `${this.agoraConfig.getConfig().apiBaseUrl}${this.agoraConfigObject.agenda}fetchAgendaListByMeetingId/${meetingId}`,
    { headers: this.commonHeaders }
  );
}

 getAllProteanForm(req:any){
  const headers = this.commonHeaders
    .set('x-custom-page', String(req.page))
    .set('x-custom-size', String(req.size));
  // const commonHeaders = new HttpHeaders().set('Content-Type', 'application/json;charset=utf-8').set("Access-Control-Allow-Origin", "*").set("Access-Control-Allow-Headers", "*").set("Access-Control-Allow-Methods", "GET,POST,PUT,DELETE").set("x-custom-page",String(req.page)).set("x-custom-size",String(req.size));
  return this.http.get<any>(`${this.agoraConfig.getConfig().apiBaseUrl}${this.agoraConfigObject.getAllProteanForm}`, { headers: headers, observe: 'response' });
 }

 saveFormDetails(req:any){
this.commonHeaders = new HttpHeaders().set('Content-Type', 'application/json;charset=utf-8').set("Access-Control-Allow-Origin", "*")
      .set("Access-Control-Allow-Headers", "*")
      .set("Access-Control-Allow-Methods", "GET,POST,PUT,DELETE")
      .set("x-userId",localStorage.getItem('userId')+"");
  return this.http.post<any>(`${this.agoraConfig.getConfig().apiBaseUrl}${this.agoraConfigObject.saveFormResponse}`,req, { headers: this.commonHeaders, observe: 'response' });
 }

  saveOrUpdateForm(formReq:any){
  return this.http.post<any>(`${this.agoraConfig.getConfig().apiBaseUrl}${this.agoraConfigObject.note}`+'updateFormDetails',formReq, { headers: this.commonHeaders, observe: 'response' });
 }
getFormResponseDetails(req:any){
  return this.http.post<any>(`${this.agoraConfig.getConfig().apiBaseUrl}${this.agoraConfigObject.getFormResposeDetails}`,req, { headers: this.commonHeaders, observe: 'response' });
 }
  getFormDetails(formId:any){
  return this.http.post<any>(`${this.agoraConfig.getConfig().apiBaseUrl}${this.agoraConfigObject.getFormDetails}`,formId, { headers: this.commonHeaders, observe: 'response' });
 }

 saveFormResponse(req:any,noteId:String,endPath:any){
  return this.http.post<any>(`${this.agoraConfig.getConfig().apiBaseUrl}${this.agoraConfigObject.formResposeDetails}`+endPath+noteId,req, { headers: this.commonHeaders, observe: 'response' });
 }

 getFormData(req:any){
  return this.http.post<any>(`${this.agoraConfig.getConfig().apiBaseUrl}${this.agoraConfigObject.note}`+'getFormData',req, { headers: this.commonHeaders, observe: 'response' });
 }

}
